export default __webpack_public_path__ + "static/media/morteza-f-shojaei-8K9UGVCZGpw-unsplash (1).0b497daa.png";